<template>
  <div class="published-knowledge-section">
    <div class="subject-wrap">
      <div>
        <ExampleHeader
          title="发布的知识"
          :number="publishedKnowledgeTotal"
          :description="knowledgeIntroduction"
          @moreAction="goToKnowledgeList"
        >
        </ExampleHeader>
        <div class="subject-item-wrapper" v-loading="loading" element-loading-text="加载中...">
          <SubjectListItem v-for="(info, key) in publishedKnowledgeList" :key="key" :info="info"></SubjectListItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExampleHeader from '@/components/home/exampleHeader.vue'
import SubjectListItem from '@/components/home/SubjectListItem.vue'
import {subjectList} from '@/api/subject'
import {formatTimeFilter} from '@/utils/index'

export default {
  name: 'PublishedKnowledgeSection',
  components: {
    ExampleHeader,
    SubjectListItem
  },
  props: {
    consultantId: {
      type: [String, Number],
      required: true
    },
    employeeId: {
      type: [String, Number],
      required: true
    },
    isConsult: {
      type: Boolean,
      default: false
    },
    consultantInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      publishedKnowledgeList: [],
      publishedKnowledgeTotal: 0,
      knowledgeIntroduction: '',
      loading: false
    }
  },
  created() {
    this.loadPublishedKnowledge()
  },
  methods: {
    // 加载发布的知识列表
    async loadPublishedKnowledge() {
      this.loading = true
      try {
        const params = {
          pageNum: 1,
          pageSize: 4,
          order: 3, // 按发布时间降序排列
          employeeId: this.employeeId,
          queryType: 1 // 我发布的
        }
        if (this.isConsult) {
          params.consultFlag = 1
        }

        const response = await subjectList(params)

        if (response.code === 200) {
          this.publishedKnowledgeList = response.data.records || []
          this.publishedKnowledgeTotal = response.data.total || 0
        } else if (response.code === 200009) {
          // 未登录处理
          this.$store.commit('ChangeSearchInput', '')
          this.$router.push({
            path: '/login'
          })
        } else {
          this.$message.error(response.msg || '加载发布知识失败')
        }
      } catch (error) {
        console.error('加载发布知识失败:', error)
        this.$message.error('加载发布知识失败')
      } finally {
        this.loading = false
      }
    },

    // 跳转到知识列表页
    goToKnowledgeList() {
      this.$router.push({
        path: '/techVideo',
        query: {
          employeeId: this.employeeId,
          queryType: 1, // 我发布的
          employeeName: this.consultantInfo.nickName,
          employeePhotoUrl: this.consultantInfo.headPicUrl
        }
      })
    },

    // 格式化时间（参考techVideo的实现）
    formatTimeFilter
  }
}
</script>

<style lang="scss" scoped>
.published-knowledge-section {
  width: 1200px;
  padding: 32px;
  box-sizing: border-box;
  margin-top: 32px;
  background: #fff;
  border-radius: 8px;

  .subject-wrap {
    .subject-item-wrapper {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
      margin-top: 16px;
      /deep/ .list {
        width: 260px;
      }
    }
  }
}
</style>
